import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const namirniceAdapter = createEntityAdapter({})

const initialState = namirniceAdapter.getInitialState()

export const namirniceApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllNamirnice: builder.query({
            query: () => ({
                url: '/namirnice',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedfa = responseData.map(fa => {
                    fa.id = fa._id
                    return fa
                });
                return namirniceAdapter.setAll(initialState, loadedfa)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Namirnice', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Namirnice', id }))
                    ]
                } else return [{ type: 'Namirnice', id: 'LIST' }]
            }
        }),
        addNewNamirnicu: builder.mutation({
            query: initialUserData => ({
                url: '/namirnice',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Namirnice', id: "LIST" }
            ]
        }),
        updateNamirnicu: builder.mutation({
            query: initialUserData => ({
                url: '/namirnice',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Namirnice', id: arg.id }
            ]
        }),
        deleteNamirnicu: builder.mutation({
            query: ({ id }) => ({
                url: `/namirnice`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Namirnice', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetAllNamirniceQuery,
    useAddNewNamirnicuMutation,
    useDeleteNamirnicuMutation,
    useUpdateNamirnicuMutation
} = namirniceApiSlice